// ----------------------------------------------------------------------
// <copyright file="Izenda.CommonTree.jsx" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS. </copyright>
// ----------------------------------------------------------------------

!(function() {
  var React = require('react');
  var SearchTextBox = require('share/components/controls/Izenda.SearchTextBox');
  var connect = require('share/enhancers/Izenda.Connect');
  var observer = require('mobx-react').observer;
  var compose = require('recompose').compose;
  var mapProps = require('recompose').mapProps;
  var withHandlers = require('recompose').withHandlers;
  var Input = require('share/components/controls/Izenda.Input');
  var TextHighLight = require('share/components/controls/Izenda.TextHighLight');
  var TreeView = require('share/components/controls/Izenda.TreeView');
  const { curry, filter, get } = require('lodash/fp');

  var checkboxAction = compose(
    withHandlers({
      onCheck: curry(function(props, e) {
        props.node.check(null);
      })
    })
  );

  var LeafNodeCheckBox = connect(checkboxAction)(function(props) {
    var node = props.node;

    return (
      <Input
        indeterminate={node.displayCheckedStatus === 0}
        type="checkbox"
        checked={node.displayCheckedStatus === 1}
        onChange={props.onCheck}
        disabled={node.disabledCheckBox || props.readOnly}
      />
    );
  });

  var LeafNodeText = observer(function(props) {
    return <TextHighLight highlight={props.node.hightLightText} text={props.node.nodeText} className="u_textNormal" />;
  });

  var NumberIndicator = observer(function(props) {
    var node = props.node;
    if (!node.showNumChildren || !node.isBranchNode) {
      return null;
    }
    return <span>{String.format(' ({0})', node.numberOfChildren)}</span>;
  });

  var renderNode = function(node, toggleIcon) {
    return (
      <div className="checkbox u_noMarginAll">
        <label>
          <LeafNodeCheckBox node={node} />
          <LeafNodeText node={node} />
          <NumberIndicator node={node} />
        </label>
        {toggleIcon}
      </div>
    );
  };

  var CommonTreeSearch = compose(
    observer,
    mapProps(function(props) {
      return {
        value: props.filter.text,
        onChange: function(e) {
          props.filter.text = e.target.value;
        }
      };
    })
  )(SearchTextBox);

  var CommonTreeBody = observer(function(props) {
    var filtersNode = filter('isDisplayNode', props.nodes);

    return (
      <TreeView
        className="u_paddingRight"
        nodes={filtersNode}
        renderNode={renderNode}
        getKey={get('key')}
        getChildNodes={get('displayChildNodes')}
        collapsed={false}
      />
    );
  });

  var CommonTree = connect()(function(props) {
    return (
      <div className="izenda-CommonTree u_table u_fullSize u_borderAll">
        <div className="u_tableRow">
          <div className="u_tableCell u_paddingAll u_borderBottom">
            {props.headerIcon && <span className={props.headerIcon} />}
            <span className="u_textBold">{props.header}</span>
          </div>
        </div>
        <div className="u_tableRow">
          <div className="u_tableCell u_paddingAll u_borderBottom">
            <div className="u-posRelative">
              <CommonTreeSearch {...props} />
            </div>
          </div>
        </div>
        <div className="u_tableRow">
          <div className="u_tableCell u_fullSize">
            <CommonTreeBody nodes={props.nodes} />
          </div>
        </div>
      </div>
    );
  });

  CommonTree.propTypes = {
    nodes: React.PropTypes.array.isRequired,
    filter: React.PropTypes.object.isRequired
  };

  module.exports = CommonTree;
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/CommonTree/Izenda.CommonTree.jsx